// extracted by mini-css-extract-plugin
module.exports = {"StatusA":"eu_StatusA__dqLxf"};